import Route from '@ember/routing/route'
import type Transition from '@ember/routing/transition'
import type BookLibrarySharesByCollectionShowController from './controller'

interface Params extends Record<string, unknown> {
  share_id: string
}

export default class BookLibrarySharesByCollectionShowRoute extends Route {
  model(params: Params) {
    const { subscriptionType } = this.modelFor('subscription-type') as ModelForSubscriptionTypeRoute
    return { shareId: params.share_id, subscriptionType }
  }

  setupController(
    controller: BookLibrarySharesByCollectionShowController,
    model: ModelFor<BookLibrarySharesByCollectionShowRoute>,
    transition: Transition,
  ) {
    super.setupController(controller, model, transition)

    void controller.fetchStudentsForShare.perform({ shareId: model.shareId })
  }
}
